import { render, staticRenderFns } from "./PrepClassesTable.vue?vue&type=template&id=45001ab2&"
import script from "./PrepClassesTable.vue?vue&type=script&lang=js&"
export * from "./PrepClassesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports